import { percent } from "../../lib/format.js";

/** A thin bar with the number beside it, and a tick at the tenant's threshold. */
export function ConfidenceBar({ value, threshold }: { value: number; threshold: number }) {
  const below = value < threshold;
  return (
    <div className={`confidence${below ? " is-below" : ""}`}>
      <div className="confidence-track" role="meter" aria-valuemin={0} aria-valuemax={1} aria-valuenow={value} aria-label="Confidence">
        <span className="confidence-fill" style={{ width: `${percent(value)}%` }} />
        <span className="confidence-threshold" style={{ left: `${percent(threshold)}%` }} title={`Threshold ${threshold.toFixed(2)}`} />
      </div>
      <span className="confidence-value mono">
        {value.toFixed(2)}
      </span>
    </div>
  );
}
